export default "__VITE_ASSET__dbb5539e__"